import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Blur extends BaseOption {
  static userInterfaceComponent = {
    label: "Blur",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      max: 10,
      append: "px",
      defaultEmptyValue: 0,
    },
  };

  static defaultValue = 0;

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue == 0) {
      return 0;
    }
    return `${configValue}px`;
  }
}
